import React, { Component } from 'react'

export default class ReQuotationComponent extends Component {
    render() {
        const {filterQuotation} = this.props
        return (
            <div className="col-xl-3 col-lg-6 quotation-component" onClick={filterQuotation}>
                <div className="card card-stats mb-4 mb-xl-0">
                    <div className="card-body" >
                        <div className="row">
                            <div className="col">
                                {/* <h5 className="card-title text-uppercase text-muted mb-0" /> */}
                                <span className="h4 font-weight-bold mb-0">{this.props.heading}</span>
                            </div>
                        </div>
                        <p className="mt-3 mb-0 text-muted text-sm">
                        <i className={this.props.style} /><span className="text-primary font-weight-900 form-control-lg mr-2"> {this.props.count} </span>
                            <span className="text-nowrap">{this.props.subHeading}</span>
                        </p>
                    </div>
                </div>
            </div>

        )
    }
}
